
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  import { Playground } from 'docz';
import State from '../../../../docs/State';
import NativeSelect from '@devsisters/ui-admin/lib/NativeSelect';

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}>
<MDXTag name="h1" components={components} props={{"id":"nativeselect"}}>{`NativeSelect`}</MDXTag>
<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-tsx"}}>{`import NativeSelect from '@devsisters/ui-admin/lib/NativeSelect';
`}</MDXTag></MDXTag>
<Playground __position={0} __code={'<State initialState={{ value: null }}>\n  {({ state: { value }, setState }) => (\n    <NativeSelect\n      placeholder=\"좋아하는 과일을 선택해주세요.\"\n      value={value}\n      options={[\n        { id: \'0\', name: \'사과\' },\n        { id: \'1\', name: \'포도\' },\n        { id: \'2\', name: \'딸기\' },\n      ]}\n      onChange={value => {\n        setState({ value })\n      }}\n    />\n  )}\n</State>'} __scope={{props: this ? this.props : props,State,NativeSelect}}>
  <State initialState={{ value: null }}>
    {({ state: { value }, setState }) => (
      <NativeSelect
        placeholder="좋아하는 과일을 선택해주세요."
        value={value} 
        options={[
          { id: '0', name: '사과' },
          { id: '1', name: '포도' },
          { id: '2', name: '딸기' }
        ]} 
        onChange={value => { setState({ value }) }}
      />
    )}
  </State>
</Playground>
           </MDXTag>
  }
}
  